var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{on:{"click":_vm.confirmDelete}},[_c('feather-icon',{attrs:{"icon":"TrashIcon","size":"15","color":"red"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }